export function obterListaTipoMovimentacao() {
  return (
    [
      { label: 'Saída', value: 'SAIDA' },
      { label: 'Entrada', value: 'ENTRADA' },
    ]
  );
}
